import React from 'react';
import BrowserLink from '../../../../../components/BrowserLink';
import * as cl from './LockedContent.module.scss';


const LockedContent = ({link = '#'}) => {
  return (
    <div className={cl.wrapper}>
      <p className={cl.purchase}>
        <span>To access this content, you must purchase </span>
        <BrowserLink href={link} className={cl.purchase__link}>Poker Coaching Premium Membership.</BrowserLink>
      </p>
    </div>
  );
};

export default LockedContent;
